import { render, staticRenderFns } from "./leverage-margin.vue?vue&type=template&id=769f287e&"
import script from "./leverage-margin.vue?vue&type=script&lang=js&"
export * from "./leverage-margin.vue?vue&type=script&lang=js&"
import style0 from "./leverage-margin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports